/* eslint-disable */
const getChips = require.context('./', false, /.png$/)
export const allChips = [10, 50, 100, 500, 1000, 5000, 10000].reverse()
export const getChipsImg = (key) => {
  return getChips(`./${key}.png`)
}

export function amountToChips(n,m = []) {
  m.sort((a, b) => b - a)
  const ret = []
  for (let i = 0; i < m.length; i++) {
    while (n >= m[i] && n > 0) {
      ret.push(m[i])
      n -= m[i]
    }
  }
  return ret
}
